/**
 * Class description
 *
 * Created: 2018-05-08
 * @author jonas
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";

import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {BetLineEvent} from "@nolimitcity/slot-game/bin/core/betline/event/BetLineEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {DirtyWildsLayerConfig} from "../../config/DirtyWildsLayerConfig";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {EnvironmentSpine} from "../environment/parts/EnvironmentSpine";
import {DirtyWildsGameAssets} from "../DirtyWildsGameAssets";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TweenMax, Linear, TimelineMax, TweenLite, TimelineLite} from "gsap";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {IAdjacentBetLineWinData} from "../../utils/SymbolUtil";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {DirtyWildsSpineAnimationNames} from "../../config/DirtyWildsSpineAnimationNames";

export class DirtyWildsBetLinesEvent extends BetLineEvent{
    public static readonly SHOW_INITIAL_BETLINE:string = "dirtyWildsBetLinesEvent_showInitialBetlines";
}

export class DirtyWildsBetLines extends BaseView {
    private _layer:ScalableLayer;
    private _betLinesData:number[][];
    private _symSize:PIXI.Point;
    private _betLineSpine:PIXI.spine.Spine;
    private _betLines:PIXI.Graphics[];
    private _offset:PIXI.Point;

    constructor() {
        super();
        this._layer = StageManager.getLayer(DirtyWildsLayerConfig.BET_LINES.name);
        this._layer.addChild(this);
    }


    protected initAnimations():void {
        this._symSize = new PIXI.Point(GameConfig.instance.SYMBOL_WIDTH, GameConfig.instance.SYMBOL_HEIGHT);
        this._offset = new PIXI.Point(
            GameConfig.instance.REEL_AREA_POS_X + GameConfig.instance.SYMBOL_WIDTH * 0.5,
            GameConfig.instance.REEL_AREA_POS_Y + GameConfig.instance.SYMBOL_HEIGHT * 0.5
        );
        this._betLineSpine = new PIXI.spine.Spine(GameResources.getSpineAsset(DirtyWildsGameAssets.FIREBALL_TRAIL_SPINE));
        this.addChild(this._betLineSpine);
    }

    protected addEventListeners():void {
        EventHandler.addEventListener(this, BetLineEvent.SHOW_WIN_BET_LINE, (event:GameEvent) => this.onShowWinBetLine(event.params[0]));
        EventHandler.addEventListener(this, BetLineEvent.HIDE_ALL_BET_LINES, (event:GameEvent) => this.onHideAllBetLines());
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, DirtyWildsBetLinesEvent.SHOW_INITIAL_BETLINE, (event:GameEvent) => this.showInitialBetlines(event.params[0], event.params[1]));
    }

    private onInitDataParsed(data:ParsedInitData):void {
        this._betLinesData = data.betLines;
    }

    private clearContainer(elementsArray:any[]):void{
        for(let i=0;i<elementsArray.length;i++){
            this.removeChild(elementsArray[i]);
        }
    }

    private showInitialBetlines(direction:string, betlineData:IAdjacentBetLineWinData[]):TimelineLite{
        let _this = this;
        let spineArray:PIXI.spine.Spine[] = [];
        let betlineTimeLine:TimelineLite = new TimelineLite({paused: true, onComplete: () => {
                _this.clearContainer(spineArray);
            }});
        let betWinData:IAdjacentBetLineWinData[] = betlineData.filter((a) => { return a.lineStart === direction});
        for(let i = 0; i < betWinData.length; i++){
            let betLineWinData:IAdjacentBetLineWinData = <IAdjacentBetLineWinData>betWinData[i];
            let betLineSpine = new PIXI.spine.Spine(GameResources.getSpineAsset(DirtyWildsGameAssets.FIREBALL_TRAIL_SPINE));
            this.addChild(betLineSpine);
            spineArray.push(betLineSpine);
            betlineTimeLine.add(this.onShowWinBetLine(betLineWinData, betLineSpine), 0);
        }
        betlineTimeLine.play();
        return betlineTimeLine;
    }

    private onShowWinBetLine(betlineData:IAdjacentBetLineWinData, betlineSpine:any = null):TimelineLite {
        // this._betLines[betlineData.betLineIndex].visible = true;
        betlineSpine = betlineSpine? betlineSpine : this._betLineSpine;
        let betlineAnim:string = "B0";
        let betPos:PIXI.Point = new PIXI.Point(4 * this._offset.x + 10, this._offset.y + ((betlineData.betLineIndex % 3) * GameConfig.instance.SYMBOL_HEIGHT));
        switch (betlineData.betLineIndex){
            case 0:
            case 1:
            case 2:
                betlineAnim = "B0";
                break;
            case 3:
            case 4:
                betlineAnim = "B3";
                break;
            case 5:
                betlineAnim = "B5";
                betPos.y = this._offset.y + GameConfig.instance.SYMBOL_HEIGHT;
                break;
            case 6:
                betlineAnim = "B5";
                betPos.y = this._offset.y + (2 * GameConfig.instance.SYMBOL_HEIGHT);
                break;
            case 7:
                betlineAnim = "B7";
                betPos.y = this._offset.y;
                break;
            case 8:
                betlineAnim = "B8";
                break;
            case 9:
                betlineAnim = "B9";
                break;
        }
        if(betlineData.lineStart === "Right" &&  betlineData.betLineIndex === 9){
            betlineAnim = "B10";
            betPos.y = this._offset.y + (2 * GameConfig.instance.SYMBOL_HEIGHT);
        }
        betlineSpine.position.set(betPos.x, betPos.y);
        const tl:TimelineLite = new TimelineLite();
        tl.add(new TweenLite(betlineSpine.scale, 0.01, {x : (betlineData.lineStart === "Right" &&  betlineData.betLineIndex !== 9)? -1 : 1}));
        tl.add(new SpineTween(betlineSpine, 0, betlineAnim));
        return tl;
    }


    private onHideAllBetLines() {
        // for(let line of this._betLines) {
        //     line.visible = false;
        // }
        const tl:TimelineLite = new TimelineLite();
        tl.add(new SpineTween(this._betLineSpine, 0, null));
    }


    private drawLines():void {
        if(this._betLinesData == undefined || this._symSize == undefined) {
            return;
        }

        const lines:PIXI.Graphics[] = [];

        for(let lineData of this._betLinesData) {
            const line = new PIXI.Graphics();

            line.lineStyle(4, 0x724e10, 1);
            line.moveTo(0, this._symSize.y * lineData[0]);
            line.lineTo(this._symSize.x, this._symSize.y * lineData[1]);
            line.lineTo(this._symSize.x * 2, this._symSize.y * lineData[2]);
            line.lineTo(this._symSize.x * 3, this._symSize.y * lineData[3]);
            line.lineTo(this._symSize.x * 4, this._symSize.y * lineData[4]);
            line.position.set(this._offset.x, this._offset.y);
            line.blendMode = PIXI.BLEND_MODES.ADD;
            line.visible = false;
            lines.push(line);

        }
        this._betLines = lines;

        for(let line of this._betLines) {
            this.addChild(line);
        }
    }
}